import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Wrench, MapPinLine, Star, ArrowRight } from "@phosphor-icons/react";

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="bg-[#0a0a0a] text-white">
      <section className="border-b border-white/10 grain relative">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 relative">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FFC107] mb-4">// About</p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight leading-[0.95] max-w-4xl">
            We sell <span className="text-[#FFC107]">peace</span> of mind by the kilogram.
          </h1>
          <p className="mt-8 text-xl text-zinc-300 max-w-3xl leading-relaxed">
            ObraSafe started in 2021 in a workshop at Lionsgate Residence, Accra, after one too many friends had their motorbikes vanish from outside their homes. We built our first disc lock, tested it on Friday night markets, and have not stopped engineering since.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FFC107] mb-4">// Mission</p>
          <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
            Make theft expensive. Make ownership simple.
          </h2>
        </div>
        <div className="md:col-span-7 text-lg text-zinc-300 leading-relaxed space-y-5">
          <p>
            We import, assemble, and engineer in Ghana. Every product passes a four-step torture test — bolt cutter, hacksaw, freeze attack, and corrosion bath — before we sell it.
          </p>
          <p>
            Our customers are okada riders, taxi drivers, family-car owners, logistics fleets, schools, and security firms. We tune our pricing for the Ghanaian wallet — Mobile Money supported on day one, no awkward forex spreads, no upselling.
          </p>
        </div>
      </section>

      <section className="bg-[#141414] border-y border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-24">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#FFC107] mb-4">// Pillars</p>
          <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight mb-12">What we stand on.</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { i: ShieldCheck, t: "Build Hard", b: "Materials, cylinders, and battery life chosen as if our family rode the bike." },
              { i: Wrench, t: "Install Right", b: "Certified technicians in Accra, Kumasi, Tamale, Takoradi. No shortcuts." },
              { i: MapPinLine, t: "Serve Ghana", b: "Designed for our climate, our roads, our networks (MTN, Vodafone, AirtelTigo)." },
              { i: Star, t: "Stand Behind", b: "12–24 month warranty + lifetime spare-part support on every product." },
            ].map((p, i) => (
              <div key={p.t} className="border border-white/10 p-6 bg-[#0a0a0a]" data-testid={`about-pillar-${i}`}>
                <p.i size={32} weight="duotone" className="text-[#FFC107] mb-4" />
                <h3 className="font-display text-xl font-bold mb-2">{p.t}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{p.b}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 text-center">
        <h3 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight mb-6">
          Ready to lock your ride?
        </h3>
        <Link to="/products" data-testid="about-cta" className="inline-flex items-center gap-2 h-13 px-8 py-4 bg-[#FFC107] hover:bg-[#FFB300] text-black font-black uppercase tracking-wider text-sm">
          Browse the catalog <ArrowRight size={18} weight="bold" />
        </Link>
      </section>
    </div>
  );
}
